import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NotAllowCustGroup" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotAllowCustGroup',
  setup(__props) {

initEmptyParam()
const store = useStore()


const queryParam = {
  sysDate: dayjs().startOf('date').format('YYYY-MM-DD')
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}
// 定义筛选规则
const filterRules = [
  '筛选规则：',
  '1、成交客户',
  '2、5个月内回复过的客户',
  '3、5个月内未回复且加入时间未满6月',
]
const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "notAllowCustGroup",
      pageUrl: "/main/custGroup/queryNotAllowCustGroupList",
      downUrl: "/main/custGroup/download",
      downFilename: "不允许拉群客户群组.xlsx",
      filterRules: filterRules,
      onDownBtnClick: _unref(handleDownBtnClick)
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})